import { Injectable } from '@angular/core';

import { switchMap, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

import { HttpRequestService} from '../../../_services';
import { Observable  } from 'rxjs';
import { BuildUrlBody, SmagUser, Login } from '../../../_models';
import { localStorageService } from '../../../_services/local-storage.service';


const GET_IDENTITIES_ACTION = environment.BeApiOperational.getidentities;
const CHECK_SMAG_ACCOUNT = environment.BeApiOperational.checksmagaccount;
//Api refresh smagToken + legacytoken
const REFRESH_SMAG_ACCOUNT = environment.BeApiOperational.refreshSmagToken;

/* global exposé par le bundle account-front.umd.js (nouveau SmagButton Vue/SmagLib) */
declare var AccountFront: any;

@Injectable()
export class SmagAccountService {

   public smag_account_url: string = "";
   public account_exists: boolean;
   public show_close_button;

  private baseUrl = environment.BeApiOperational.url;
  private _smag_token:string="";
  private _smag_refresh_token:string="";
  private smagButtonContainerSelector:string =".smag-button-container";
  private nativeWindowOpen: typeof window.open | null = null;
  private smagLogoutRedirectTimer: any = null;


  getSmagUser():any|null
  {
   return localStorageService.GetJsonSmagUserBrut(true);
  }

  setSmagUser(smag_user:SmagUser) {
    localStorageService.SetSmagUser(smag_user);
  }

  setSmagToken(token:string) {
    this._smag_token = token;
  }

  setSmagRefreshToken(refresh_token: string) {
    this._smag_refresh_token = refresh_token;
  }

   constructor(private httpRequestService: HttpRequestService, protected router: Router){}



   /**
    * Retourne l'url de connexion au compte SMAG
    * @param legacy_id Identifiant legacy de l'utilisateur
    * @returns
    */
   getSmagAccountUrl(data?:any) : Observable<any>{
      let encrypted_user_id:string = '';
      let displaySignUp = "0"; //Afficher l'onglet creation de compte sur l'iframe compte Smag
      let displayLogin = "1"; //Afficher l'onglet connexion sur l'iframe compte Smag

      if (data) {
         this.account_exists = data.account_exists != 'false';
         if (!this.account_exists) {
            encrypted_user_id = data.encrypted_legacy_id;
            displayLogin = "0";
            displaySignUp = "1";
         }
      }
      let body = new BuildUrlBody(environment.SmagAccount.ApplicationId, displaySignUp, displayLogin, encrypted_user_id != '' ? encrypted_user_id: null);

      return this.httpRequestService.PostRequest(environment.SmagAccount.UrlBuildAuth, body, 'getSmagAccountUrl', true)
        .pipe(map(
          (response) => {return response;},
          (error) => {
            throw new Error('Error when getting Smag Account Url');
         })
      )
   }

   getUrl(encrypted_user_id):string {
      if (this.smag_account_url == "") {
         this.getSmagAccountUrl(encrypted_user_id).subscribe((result) => {
            this.smag_account_url = result;
            return result;
         });
      } else {
         return this.smag_account_url;
      }
   }


  // Service message commands
  setShowCloseButton(close_button: boolean) {
    this.show_close_button = close_button;
  }

  //récupération des profils actifs de l'utilisateur
  getActiveUserProfils(smag_token:string, smag_refresh_token:string): any {
      const body = {
         'smag_token': smag_token,
         'smag_refresh_token' : smag_refresh_token,
         'application_id': environment.SmagAccount.ApplicationId,
         'only_active_profil' : true
      };
      return this.httpRequestService.post(this.baseUrl + GET_IDENTITIES_ACTION, body, 'getUsers')
        .pipe(
          map(
            (response) => {
             return response;
          })
        );
    }

    /**
     * Refresh Smag Token + Legacy Token
     * @param smag_refresh_token
     * @param user_legacy_id
     * @returns
     */
    refreshSmagAccount( smag_refresh_token:string, user_legacy_id:string): any {
      //authentification Header comporte token smag + token Legacy
      const body = {
         'smag_refresh_token' : smag_refresh_token,
         'legacyId' : user_legacy_id ?? ""
      };
      return this.httpRequestService.post(this.baseUrl + REFRESH_SMAG_ACCOUNT, body, 'refreshToken')
        .pipe(
          map(
            (response) => {
             return response;
          })
        );
    }

  checkCurrentUser() : Observable<any>{
      // Récupération depuis le localStorage
      let currentUser = localStorageService.GetJsonLogin(false);
      let body = {
         'application_id' : environment.SmagAccount.ApplicationId,
         'jarvis_token': currentUser.token
      };
      return this.httpRequestService.post(this.baseUrl + CHECK_SMAG_ACCOUNT, body, 'checkCurrentUser')
         .pipe(map(res => res))
         .pipe(switchMap((data:any) =>
            this.getSmagAccountUrl(data)
         ))
         .pipe(
           map(res => {
            let result = {};
            result['account_exists'] = this.account_exists;
            result['smag_account_url'] = res;
            return result;
         })
      );
   }

   public loadSmagButtonLibraries(){
    let smag_user = this.getSmagUser();
    if (smag_user == null) {
      return;
    }
    this._smag_token = smag_user.smag_token;
    this._smag_refresh_token = smag_user.smag_refresh_token;

    //Check if smagbutton script is already in html head
    if(document.getElementById('smagbutton')){
      this.mountSmagButton();
      return;
    }


    //smagbutton script is not in head...load it
    let smagbuttonscript = document.createElement('script');
    smagbuttonscript.setAttribute('id', 'smagbutton');
    smagbuttonscript.setAttribute('type', 'text/javascript');
    smagbuttonscript.setAttribute('src', environment.SmagAccount.SmagbuttonJs + Date.now());
    smagbuttonscript.onload = this.mountSmagButton.bind(this);

    document.getElementsByTagName('head')[0].appendChild(smagbuttonscript);
  }

  private mountSmagButton() {
    var that = this;
    // Construction du SmagButton (nouveau composant Vue exposé par le bundle account-front)
    AccountFront.SmagButton(this.smagButtonContainerSelector, {
      methods: {
        logout() {
          that.OnSignOut();
        },
        onTokenExpired() {
          that.OnSignOut();
        }
      },
      data() {
        return {
          token: that._smag_token,
          refreshToken: that._smag_refresh_token,
        };
      },
      template: '<SmagButton :token="token" :refreshToken="refreshToken" @logout="logout" @tokenExpired="onTokenExpired"/>'
    });
    this.neutralizeSmagButtonFixedPositioning();
  }

  /**
   * Le widget SmagButton s'attache en Shadow DOM (mode "open") sur le conteneur pour
   * s'isoler du style de l'app hôte : aucun CSS écrit depuis notre stylesheet ne peut
   * donc l'atteindre, quelle que soit sa spécificité. Son icône cliquable y est rendue
   * avec les classes utilitaires "w-min h-min fixed top-0 left-0 ..."
   * (position:fixed;top:0;left:0 en !important), pensées pour un bouton flottant au
   * coin de la fenêtre. On ne peut donc la neutraliser qu'en passant par le style
   * inline de l'élément, via une référence JS au shadowRoot (le Shadow DOM bloque le
   * CSS externe mais pas l'accès JS, tant qu'il est en mode "open").
   * Le panneau latéral du widget (classes "fixed h-full w-none ...") n'est pas
   * concerné : on cible uniquement le wrapper de l'icône via "w-min.h-min.fixed".
   * Son parent direct ("smag-instance smag-module-instance", racine de l'app Vue
   * montée dans le shadow root) occupe tout le conteneur (display:block, ~100%
   * largeur/hauteur) sans centrer son contenu : une fois l'icône remise en flux
   * normal, elle se retrouve donc en haut à gauche de ce wrapper. On force ce
   * wrapper en flex centré pour obtenir le centrage visuel dans .smag-button-container.
   * Le montage Vue dans le shadow root n'est pas garanti synchrone : on retente donc
   * à intervalles courts pendant quelques secondes plutôt que d'observer le host (les
   * mutations à l'intérieur d'un shadow root ne remontent pas via un MutationObserver
   * posé sur l'élément hôte).
   */
  private neutralizeSmagButtonFixedPositioning(): void {
    const container = document.querySelector(this.smagButtonContainerSelector) as HTMLElement;
    if (!container) {
      return;
    }
    const pin = (el: HTMLElement) => {
      el.style.setProperty('position', 'static', 'important');
      el.style.setProperty('top', 'auto', 'important');
      el.style.setProperty('left', 'auto', 'important');
      el.style.setProperty('margin', '0', 'important');
      const wrapper = el.parentElement;
      if (wrapper) {
        wrapper.style.setProperty('display', 'flex', 'important');
        wrapper.style.setProperty('align-items', 'center', 'important');
        wrapper.style.setProperty('justify-content', 'center', 'important');
      }
    };
    let attempts = 0;
    const tryPin = () => {
      const el = container.shadowRoot?.querySelector('.w-min.h-min.fixed') as HTMLElement;
      if (el) {
        pin(el);
        return;
      }
      if (++attempts < 50) {
        setTimeout(tryPin, 100);
      }
    };
    tryPin();
  }

  /**
   * Déconnexion de l'utilisateur au clic sur le bouton de déconnexion du compte Smag,
   * ou lorsque le token Smag est expiré (callback onTokenExpired)
   */
  public OnSignOut(){
    this.installTemporarySmagLogoutRedirectGuard();
    this._smag_token = "";
    this._smag_refresh_token = "";
    this.clearAsyncSmagAccount().then(() => {
      this.router.navigateByUrl('/home', { onSameUrlNavigation: 'reload' });
    })
  }

  private installTemporarySmagLogoutRedirectGuard(): void {
    if (typeof window === 'undefined' || this.nativeWindowOpen) {
      return;
    }

    this.nativeWindowOpen = window.open.bind(window);

    window.open = ((url?: string | URL, target?: string, features?: string) => {
      const href = (typeof url === 'string' ? url : (url ? url.toString() : '')).toLowerCase();
      const isSelfNavigation = target === '_self';
      const looksLikeSmagLogout = href.includes('logout') || href.includes('signout') || href.includes('deconnect');

      if (isSelfNavigation && looksLikeSmagLogout) {
        this.clearSmagLogoutRedirectGuard();
        return window;
      }

      return this.nativeWindowOpen!(url as any, target as any, features as any);
    }) as typeof window.open;

    if (this.smagLogoutRedirectTimer) {
      clearTimeout(this.smagLogoutRedirectTimer);
    }

    this.smagLogoutRedirectTimer = setTimeout(() => {
      this.clearSmagLogoutRedirectGuard();
    }, 1500);
  }

  private clearSmagLogoutRedirectGuard(): void {
    if (this.nativeWindowOpen) {
      window.open = this.nativeWindowOpen;
      this.nativeWindowOpen = null;
    }

    if (this.smagLogoutRedirectTimer) {
      clearTimeout(this.smagLogoutRedirectTimer);
      this.smagLogoutRedirectTimer = null;
    }
  }

  /*
  * Nettoyage du compte Smag
  *
  */
  public clearSmagAccount()
  {
      localStorageService.clear();
  }

      /*
  * Nettoyage du compte Smag de manière asynchrone
  *
  */
  public async clearAsyncSmagAccount() : Promise<void>
  {
    return new Promise((resolve, reject) => {
      localStorageService.clear();
      resolve();
    });
  }

  setLogins(smag_logins) {
    localStorageService.set('smag_logins', JSON.stringify(smag_logins));
  }

  getLogins() {
    return JSON.parse(localStorageService.get('smag_logins'));
  }

  getCurrentUser() {
    return localStorageService.GetJsonSmagUserBrut(true);
  }

  /**
   * Enregistre en session et masque l'iFrame de connexion
   * @param smag_user:SmagUser
   * @param currentUser
   */
  saveLoggedUserInfos(smag_user: SmagUser, currentUser: Login) {
    localStorageService.SetCurrentUser(currentUser);
    localStorageService.SetSmagUser(smag_user);
    localStorageService.set('show_smag_iframe', JSON.stringify('false'));
  }

  /**
   * Mapping des données utilisateur smag
   * @param smag_user
   * @returns Login
   */
  private MappingUser(smag_user: SmagUser) {
    let oLogin = new Login();
    oLogin.username = smag_user.login;
    oLogin.userid = smag_user.id;
    oLogin.token = smag_user.jarvis_token;
    oLogin.smag_token = smag_user.smag_token;
    return oLogin;
  }

  /**
   * Authentifie l'utilisateur provenant du compte Smag
   * @param smag_user SmagUser utilisateur Compte Smag
   */
  public loginUser(smag_user: SmagUser) {
    this.saveLoggedUserInfos(smag_user, this.MappingUser(smag_user));
    return Promise.resolve(true);
  }
}
